import { Link } from 'react-router-dom';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#F5F2EE] border-b border-[#1C1C1C]/8">
        <div className="max-w-7xl mx-auto px-8 md:px-14 py-16 md:py-24">
          <nav className="flex items-center gap-2 text-xs text-[#1C1C1C]/35 mb-8">
            <Link to="/" className="hover:text-[#ec3145] transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line text-[10px]"></i>
            <span className="text-[#1C1C1C]/55">Cookie პოლიტიკა</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-[#1C1C1C] tracking-tight mb-4">
            Cookie პოლიტიკა
          </h1>
          <p className="text-[#1C1C1C]/45 text-base md:text-lg max-w-2xl">
            ეს გვერდი ახსნის, თუ როგორ ვიყენებთ cookies და მსგავს ტექნოლოგიებს ჩვენს ვებსაიტზე.
          </p>
          <p className="text-xs text-[#1C1C1C]/25 mt-6">ბოლო განახლება: 27 აპრილი, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-8 md:px-14 py-16 md:py-24">
        <div className="prose prose-lg max-w-none">
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">1. რა არის Cookies?</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              Cookies არის მცირე ზომის ტექსტური ფაილები, რომლებსაც ვებსაიტი ანაწყობს თქვენს მოწყობილობაზე (კომპიუტერი, ტაბლეტი ან სმარტფონი), როდესაც მას სტუმრობთ. ისინი საშუალებას გვაძლევს, ვიმახსოვროთ თქვენი პარამეტრები, უკეთ გავიგოთ, თუ როგორ იყენებთ ჩვენს საიტს, და გავაუმჯობესოთ თქვენი გამოცდილება.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              Cookies შეიძლება იყოს "სესიის" (session) cookies, რომლებიც წაიშლება ბრაუზერის დახურვისას, ან "მუდმივი" (persistent) cookies, რომლებიც ინახება თქვენს მოწყობილობაზე გარკვეული პერიოდის განმავლობაში.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">2. როგორ ვიყენებთ Cookies-ს</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ჩვენ ვიყენებთ შემდეგი ტიპის cookies-ს:
            </p>
            <div className="space-y-6">
              <div className="border border-[#1C1C1C]/8 rounded-lg p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-[#ec3145]/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-[#ec3145] text-sm"></i>
                  </div>
                  <h3 className="text-base font-bold text-[#1C1C1C]">აუცილებელი Cookies</h3>
                </div>
                <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">
                  ეს cookies აუცილებელია ვებსაიტის ძირითადი ფუნქციებისთვის. მათ გარეშე საიტი ვერ იმუშავებს სწორად. მაგალითად: უსაფრთხოების cookies, სესიის მართვა, ფორმების გაგზავნა. ამ cookies-ს ვერ გამორთავთ, რადგან ისინი აუცილებელია საიტის ფუნქციონირებისთვის.
                </p>
              </div>
              <div className="border border-[#1C1C1C]/8 rounded-lg p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-[#ec3145]/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-bar-chart-line text-[#ec3145] text-sm"></i>
                  </div>
                  <h3 className="text-base font-bold text-[#1C1C1C]">ანალიტიკური Cookies</h3>
                </div>
                <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">
                  ეს cookies გვეხმარება გავიგოთ, თუ როგორ იყენებენ ვიზიტორები ჩვენს საიტს. ისინი აგროვებს ინფორმაციას ანონიმურად, მაგალითად: რომელ გვერდებს სტუმრობენ, რამდენ ხანს რჩებიან, რა შეცდომები ხდება. ეს ინფორმაცია გვეხმარება საიტის გაუმჯობესებაში.
                </p>
              </div>
              <div className="border border-[#1C1C1C]/8 rounded-lg p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-[#ec3145]/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-3-line text-[#ec3145] text-sm"></i>
                  </div>
                  <h3 className="text-base font-bold text-[#1C1C1C]">ფუნქციური Cookies</h3>
                </div>
                <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">
                  ეს cookies საშუალებას გვაძლევს, ვიმახსოვროთ თქვენი არჩევანი და პარამეტრები (მაგალითად: ენის არჩევანი, რეგიონი, ფონტის ზომა), რათა თქვენი მომდევნო ვიზიტები უფრო პერსონალიზებული იყოს.
                </p>
              </div>
              <div className="border border-[#1C1C1C]/8 rounded-lg p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-8 h-8 rounded-full bg-[#ec3145]/10 flex items-center justify-center flex-shrink-0">
                    <i className="ri-advertisement-line text-[#ec3145] text-sm"></i>
                  </div>
                  <h3 className="text-base font-bold text-[#1C1C1C]">მარკეტინგული Cookies</h3>
                </div>
                <p className="text-sm text-[#1C1C1C]/55 leading-relaxed">
                  ეს cookies გამოიყენება რეკლამის პერსონალიზაციისთვის. ისინი აკვირდებიან თქვენს ქცევას სხვადასხვა ვებსაიტებზე და ქმნიან თქვენს ინტერესებზე მორგებულ რეკლამას. ამ cookies-ს მხოლოდ თქვენი თანხმობით ვიყენებთ.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">3. მესამე მხარის Cookies</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ჩვენი ვებსაიტი შესაძლოა შეიცავდეს cookies-ს შემდეგი მესამე მხარეებისგან:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Google Analytics:</strong> საიტის ტრაფიკისა და მომხმარებლის ქცევის ანალიზისთვის.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Social Media:</strong> Facebook, Instagram და LinkedIn ღილაკები და ბმულები.</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">4. Cookies-ის მართვა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თქვენ შეგიძლიათ მართოთ და წაშალოთ cookies თქვენი ბრაუზერის პარამეტრების მეშვეობით. თითოეული ბრაუზერი აქვს სხვადასხვა მეთოდი cookies-ის მართვისთვის:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Google Chrome:</strong> Settings &gt; Privacy and security &gt; Cookies and other site data</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Mozilla Firefox:</strong> Preferences &gt; Privacy & Security &gt; Cookies and Site Data</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Safari:</strong> Preferences &gt; Privacy &gt; Cookies and website data</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">Microsoft Edge:</strong> Settings &gt; Cookies and site permissions &gt; Manage and delete cookies</span>
              </li>
            </ul>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mt-4">
              გთხოვთ, გაითვალისწინოთ, რომ cookies-ის გამორთვამ შეიძლება გავლენა მოახდინოს ვებსაიტის ზოგიერთ ფუნქციაზე და თქვენს გამოცდილებაზე.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">5. კონტაქტი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თუ გაქვთ კითხვები cookies-ის პოლიტიკის შესახებ, გთხოვთ დაგვიკავშირდეთ:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ელფოსტა</p>
                    <a href="mailto:info@phoenix.ge" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">info@phoenix.ge</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ტელეფონი</p>
                    <a href="tel:+995599872020" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">+995 599 87 20 20</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}